import React from "react";
import { Box, Drawer, List, makeStyles, Divider } from "@material-ui/core";
import NavItem from "./NavItem";
import { ROUTER_NAME } from "src/constants";

//--- Icon
import LayersIcon from "@material-ui/icons/Layers";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AssignmentIcon from "@material-ui/icons/Assignment";

const items = [
  {
    href: ROUTER_NAME.MAP_LAYER,
    icon: LayersIcon,
    title: "Lớp bản đồ",
    showBorder: true
  },
  {
    href: ROUTER_NAME.USER_MANAGEMENT,
    icon: AccountCircleIcon,
    title: "Quản lý người dùng",
    showBorder: true
  },
  {
    href: ROUTER_NAME.NORMAL_INFO,
    icon: AssignmentIcon,
    title: "Thay đổi logo",
    showBorder: false
  }
];

const useStyles = makeStyles(() => ({
  desktopDrawer: {
    width: 240,
    top: 70,
    height: "calc(100% - 64px)",
    backgroundColor: "#354ea9"
  }
}));

const NavBar = () => {
  const classes = useStyles();

  return (
    <Drawer
      open
      anchor="left"
      classes={{ paper: classes.desktopDrawer }}
      variant="persistent"
    >
      <Box height="100%" display="flex" flexDirection="column">
        <Box p={2}>
          <List>
            <Divider style={{ backgroundColor: "rgb(255 255 255 / 12%)" }} />
            {items.map(item => (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                subLinks={item?.subLinks || null}
                {...item}
              />
            ))}
          </List>
        </Box>
        <Box flexGrow={1} />
      </Box>
    </Drawer>
  );
};

export default NavBar;
